// 每个数组包含每一组的图标的信息
var EDBtnDataArray_0 = [
    EDMmlFormulaIndex.le,
    EDMmlFormulaIndex.ge,
    EDMmlFormulaIndex.ll,
    EDMmlFormulaIndex.gg,
    EDMmlFormulaIndex.prec,
    EDMmlFormulaIndex.succ,
    EDMmlFormulaIndex.triangleleft,
    EDMmlFormulaIndex.triangleright,
    EDMmlFormulaIndex.thicksim,
    EDMmlFormulaIndex.asymp,
    EDMmlFormulaIndex.simeq,
    EDMmlFormulaIndex.cong,
    EDMmlFormulaIndex.ne,
    EDMmlFormulaIndex.equiv,
    EDMmlFormulaIndex.triangleq,
    EDMmlFormulaIndex.hateq,
    EDMmlFormulaIndex.doteq,
    EDMmlFormulaIndex.prop,
    EDMmlFormulaIndex.plusmn,
    EDMmlFormulaIndex.minusPlus,
    EDMmlFormulaIndex.times,
    EDMmlFormulaIndex.lowast,
    EDMmlFormulaIndex.div,
    EDMmlFormulaIndex.oplus,
    EDMmlFormulaIndex.otimes,
    EDMmlFormulaIndex.odot,
    EDMmlFormulaIndex.sdot,
    EDMmlFormulaIndex.centerdot,
    EDMmlFormulaIndex.bullet,
    EDMmlFormulaIndex.scirc,
    EDMmlFormulaIndex.langle,
    EDMmlFormulaIndex.rangle,
    EDMmlFormulaIndex.lobrk,
    EDMmlFormulaIndex.robrk,
];
var EDBtnDataArray_1 = [
    EDMmlFormulaIndex.OverDot_s,

    EDMmlFormulaIndex.OverDoubleDot_s,

    EDMmlFormulaIndex.OverTripleDot_s,

    EDMmlFormulaIndex.OverDotDot_s,

    EDMmlFormulaIndex.OverShortRightArr_s,

    EDMmlFormulaIndex.OverLeftRightArrow_s,

    EDMmlFormulaIndex.OverShortLeftArr_s,

    EDMmlFormulaIndex.OverRightVector_s,

    EDMmlFormulaIndex.OverLeftRightVector_s,

    EDMmlFormulaIndex.OverLeftVector_s,

    EDMmlFormulaIndex.Enclosedown_s,

    EDMmlFormulaIndex.UnderDot_s,

    EDMmlFormulaIndex.UnderDoubleDot_s,

    EDMmlFormulaIndex.UnderTripleDot_s,

    EDMmlFormulaIndex.UnderDotDot_s,

    EDMmlFormulaIndex.UnderShortRightArr_s,

    EDMmlFormulaIndex.UnderLeftRightArrow_s,

    EDMmlFormulaIndex.UnderShortLeftArr_s,

    EDMmlFormulaIndex.UnderRightVector_s,

    EDMmlFormulaIndex.UnderLeftRightVector_s,

    EDMmlFormulaIndex.UnderLeftVector_s,

    EDMmlFormulaIndex.Encloseup_s,

    EDMmlFormulaIndex.OverBar_s,

    EDMmlFormulaIndex.OverTilde_s,

    EDMmlFormulaIndex.Parentheses_os,

    EDMmlFormulaIndex.OverParentheses_s,

    EDMmlFormulaIndex.OverHat_s,

    EDMmlFormulaIndex.OverDownhat_s,

    EDMmlFormulaIndex.SupMin_s,

    EDMmlFormulaIndex.SupSec_s,

    EDMmlFormulaIndex.SupMilliSec_s,

    EDMmlFormulaIndex.SupDegree_s,

    EDMmlFormulaIndex.Enclosehor_s,

    EDMmlFormulaIndex.UnderBar_s,

    EDMmlFormulaIndex.UnderTilde_s,

    EDMmlFormulaIndex.UnderParentheses_s,

    EDMmlFormulaIndex.Parentheses_us,

    EDMmlFormulaIndex.UnderHat_s,

    EDMmlFormulaIndex.UnderDownhat_s,

    EDMmlFormulaIndex.OverMin_s,

    EDMmlFormulaIndex.OverLefmin_s,

    EDMmlFormulaIndex.SupT_s,

    EDMmlFormulaIndex.Encloseupdown_s,
];
var EDBtnDataArray_2 = [
    EDMmlFormulaIndex.LeftRightArr,

    EDMmlFormulaIndex.RightArr,

    EDMmlFormulaIndex.LeftArr,

    EDMmlFormulaIndex.UpDownArrow,

    EDMmlFormulaIndex.UpArrow,

    EDMmlFormulaIndex.DownArrow,

    EDMmlFormulaIndex.DoubleLeftRightArr,

    EDMmlFormulaIndex.DoubleRightArr,

    EDMmlFormulaIndex.DoubleLeftArr,

    EDMmlFormulaIndex.DoubleUpDownArr,

    EDMmlFormulaIndex.DoubleUpArr,

    EDMmlFormulaIndex.DoubleDownArr,

    EDMmlFormulaIndex.LLeftURightArr,

    EDMmlFormulaIndex.UpperRightArr,

    EDMmlFormulaIndex.LowerLeftArr,

    EDMmlFormulaIndex.ULeftLRightArr,

    EDMmlFormulaIndex.LowerRightArr,

    EDMmlFormulaIndex.UpperLeftArr,

    EDMmlFormulaIndex.RightArrLeftArr,

    EDMmlFormulaIndex.Symbol_LRightArrSLeftArr,

    EDMmlFormulaIndex.Symbol_SRightArrLLeftArr,

    EDMmlFormulaIndex.Equilibrium,

    EDMmlFormulaIndex.Symbol_LRightVerSLeftVer,

    EDMmlFormulaIndex.Symbol_SRightVerLLeftVer,

    EDMmlFormulaIndex.RightTeeArr,

    EDMmlFormulaIndex.enter,
];
var EDBtnDataArray_3 = [
    EDMmlFormulaIndex.part,

    EDMmlFormulaIndex.wp,

    EDMmlFormulaIndex.Im,

    EDMmlFormulaIndex.Re,

    EDMmlFormulaIndex.aleph,

    EDMmlFormulaIndex.Ropf,

    EDMmlFormulaIndex.Zopf,

    EDMmlFormulaIndex.Copf,

    EDMmlFormulaIndex.Qopf,

    EDMmlFormulaIndex.Nopf,

    EDMmlFormulaIndex.infin,

    EDMmlFormulaIndex.hbar,

    EDMmlFormulaIndex.hlambda,

    EDMmlFormulaIndex.ell,

    EDMmlFormulaIndex.dagger,

    EDMmlFormulaIndex.Delta,

    EDMmlFormulaIndex.nabla,

    EDMmlFormulaIndex.Omega,

    EDMmlFormulaIndex.mho,

    EDMmlFormulaIndex.diamond,

    EDMmlFormulaIndex.Sum,

    EDMmlFormulaIndex.prod,

    EDMmlFormulaIndex.coprod,

    EDMmlFormulaIndex.Int,

    EDMmlFormulaIndex.circ,

    EDMmlFormulaIndex.ang,

    EDMmlFormulaIndex.measuredangle,

    EDMmlFormulaIndex.sphericalangle,

    EDMmlFormulaIndex.perp,

    EDMmlFormulaIndex.parallel,

    EDMmlFormulaIndex.bigtriangleup,

    EDMmlFormulaIndex.square,

    EDMmlFormulaIndex.rect,

    EDMmlFormulaIndex.quad,

    EDMmlFormulaIndex.bigcirc,
];
var EDBtnDataArray_4 = [
    EDMmlFormulaIndex.alpha,

    EDMmlFormulaIndex.beta,

    EDMmlFormulaIndex.chi,

    EDMmlFormulaIndex.delta,

    EDMmlFormulaIndex.epsilon,

    EDMmlFormulaIndex.lphi,

    EDMmlFormulaIndex.phi,

    EDMmlFormulaIndex.gamma,

    EDMmlFormulaIndex.eta,

    EDMmlFormulaIndex.iota,

    EDMmlFormulaIndex.kappa,

    EDMmlFormulaIndex.lambda,

    EDMmlFormulaIndex.mu,

    EDMmlFormulaIndex.nu,

    EDMmlFormulaIndex.omicron,

    EDMmlFormulaIndex.pi,

    EDMmlFormulaIndex.piv,

    EDMmlFormulaIndex.theta,

    EDMmlFormulaIndex.thetasym,

    EDMmlFormulaIndex.rho,

    EDMmlFormulaIndex.sigma,

    EDMmlFormulaIndex.sigmaf,

    EDMmlFormulaIndex.tau,

    EDMmlFormulaIndex.upsilon,

    EDMmlFormulaIndex.omega,

    EDMmlFormulaIndex.xi,

    EDMmlFormulaIndex.psi,

    EDMmlFormulaIndex.zeta,

    EDMmlFormulaIndex.Alpha,

    EDMmlFormulaIndex.Beta,

    EDMmlFormulaIndex.Chi,

    EDMmlFormulaIndex.Delta,

    EDMmlFormulaIndex.Epsilon,

    EDMmlFormulaIndex.Phi,

    EDMmlFormulaIndex.Gamma,

    EDMmlFormulaIndex.Eta,

    EDMmlFormulaIndex.Iota,

    EDMmlFormulaIndex.Kappa,

    EDMmlFormulaIndex.Lambda,

    EDMmlFormulaIndex.Mu,

    EDMmlFormulaIndex.Nu,

    EDMmlFormulaIndex.Omicron,

    EDMmlFormulaIndex.Pi,

    EDMmlFormulaIndex.Theta,

    EDMmlFormulaIndex.Rho,

    EDMmlFormulaIndex.Sigma,

    EDMmlFormulaIndex.Tau,

    EDMmlFormulaIndex.upsih,

    EDMmlFormulaIndex.Omega,

    EDMmlFormulaIndex.Xi,

    EDMmlFormulaIndex.Psi,

    EDMmlFormulaIndex.Zeta,
];
var EDBtnDataArray_5 = [
    EDMmlFormulaIndex.Parentheses_lr,

    EDMmlFormulaIndex.SquareBracket_lr,

    EDMmlFormulaIndex.CurlyBracket_lr,

    EDMmlFormulaIndex.AngleBracket_lr,

    EDMmlFormulaIndex.VerticalBars_lr,

    EDMmlFormulaIndex.DoubleVerticalBars_lr,

    EDMmlFormulaIndex.Floor_lr,

    EDMmlFormulaIndex.Ceiling_lr,

    EDMmlFormulaIndex.Floor_Ceiling,

    EDMmlFormulaIndex.DoubleBracket_lr,

    EDMmlFormulaIndex.SquareBracket_ll,

    EDMmlFormulaIndex.SquareBracket_rr,

    EDMmlFormulaIndex.SquareBracket_rl,

    EDMmlFormulaIndex.LParenthesesRSquareBracket,

    EDMmlFormulaIndex.LSquareBracketRParentheses,

    EDMmlFormulaIndex.LAngleBracketRVerticalBars,

    EDMmlFormulaIndex.LVerticalBarsRAngleBracket,

    EDMmlFormulaIndex.Parentheses_l,

    EDMmlFormulaIndex.Parentheses_r,

    EDMmlFormulaIndex.SquareBracket_l,

    EDMmlFormulaIndex.SquareBracket_r,

    EDMmlFormulaIndex.CurlyBracket_l,

    EDMmlFormulaIndex.CurlyBracket_r,

    EDMmlFormulaIndex.AngleBracket_l,

    EDMmlFormulaIndex.AngleBracket_r,

    EDMmlFormulaIndex.VerticalBars_l,

    EDMmlFormulaIndex.VerticalBars_r,

    EDMmlFormulaIndex.DoubleVerticalBars_l,

    EDMmlFormulaIndex.DoubleVerticalBars_r,

    EDMmlFormulaIndex.DoubleBracket_l,

    EDMmlFormulaIndex.DoubleBracket_r,

    EDMmlFormulaIndex.AngleBracketWithBar,

    EDMmlFormulaIndex.CurlyBracket_io,

    EDMmlFormulaIndex.CurlyBracket_iu,

    EDMmlFormulaIndex.SquareBracket_io,

    EDMmlFormulaIndex.SquareBracket_iu,

    EDMmlFormulaIndex.ParenthesesWithBar,

    EDMmlFormulaIndex.SquareBracketWithBar,

    EDMmlFormulaIndex.AngleBracketWithBar,

    EDMmlFormulaIndex.CurlyBracketWithBar,
];
var EDBtnDataArray_6 = [
    EDMmlFormulaIndex.insertMrow,

    EDMmlFormulaIndex.Frac,

    EDMmlFormulaIndex.FracBevelled,

    EDMmlFormulaIndex.Frac_old,

    EDMmlFormulaIndex.Frac_s,

    EDMmlFormulaIndex.FracBevelled_s,

    EDMmlFormulaIndex.Sqrt,

    EDMmlFormulaIndex.Root,

    EDMmlFormulaIndex.Enclose_div,

    EDMmlFormulaIndex.Sup,

    EDMmlFormulaIndex.Sub,

    EDMmlFormulaIndex.SubSup,

    EDMmlFormulaIndex.PreSup,

    EDMmlFormulaIndex.PreSub,

    EDMmlFormulaIndex.PreSubSup,

    EDMmlFormulaIndex.Indentation,

    EDMmlFormulaIndex.Space_1,

    EDMmlFormulaIndex.Space_2,

    EDMmlFormulaIndex.Empty_p,

    EDMmlFormulaIndex.Empty_b,

    EDMmlFormulaIndex.Empty_bp,

    EDMmlFormulaIndex.Empty_o, //PreEmpty_p

    EDMmlFormulaIndex.Empty_u, //PreEmpty_b

    EDMmlFormulaIndex.Empty_uo, //PreEmpty_bp

    EDMmlFormulaIndex.Space_3,

    EDMmlFormulaIndex.Space_4,

    EDMmlFormulaIndex.Space_5,

    EDMmlFormulaIndex.LargeEmpty_p,

    EDMmlFormulaIndex.LargeEmpty_b,

    EDMmlFormulaIndex.LargeEmpty_bp,

    EDMmlFormulaIndex.LargeEmpty_o, //PreLargeEmpty_p

    EDMmlFormulaIndex.LargeEmpty_u, //PreLargeEmpty_b

    EDMmlFormulaIndex.LargeEmpty_uo, //PreLargeEmpty_bp

    EDMmlFormulaIndex.Enclose_tablediv,

    EDMmlFormulaIndex.Enclose_tablediv2,
];
var EDBtnDataArray_7 = [
    EDMmlFormulaIndex.Sum,

    EDMmlFormulaIndex.Sum_u,

    EDMmlFormulaIndex.Sum_uo,

    EDMmlFormulaIndex.Sum_b,

    EDMmlFormulaIndex.Sum_bp,

    EDMmlFormulaIndex.Product,

    EDMmlFormulaIndex.Product_u,

    EDMmlFormulaIndex.Product_uo,

    EDMmlFormulaIndex.Product_b,

    EDMmlFormulaIndex.Product_bp,

    EDMmlFormulaIndex.CoProduct,

    EDMmlFormulaIndex.CoProduct_u,

    EDMmlFormulaIndex.CoProduct_uo,

    EDMmlFormulaIndex.CoProduct_b,

    EDMmlFormulaIndex.CoProduct_bp,

    EDMmlFormulaIndex.Intersection,

    EDMmlFormulaIndex.Intersection_u,

    EDMmlFormulaIndex.Intersection_uo,

    EDMmlFormulaIndex.Intersection_b,

    EDMmlFormulaIndex.Intersection_bp,

    EDMmlFormulaIndex.Union,

    EDMmlFormulaIndex.Union_u,

    EDMmlFormulaIndex.Union_uo,

    EDMmlFormulaIndex.Union_b,

    EDMmlFormulaIndex.Union_bp,

    EDMmlFormulaIndex.Land,
    EDMmlFormulaIndex.Land_u,
    EDMmlFormulaIndex.Land_uo,
    EDMmlFormulaIndex.Land_b,
    EDMmlFormulaIndex.Land_bp,

    EDMmlFormulaIndex.Lor,
    EDMmlFormulaIndex.Lor_u,
    EDMmlFormulaIndex.Lor_uo,
    EDMmlFormulaIndex.Lor_b,
    EDMmlFormulaIndex.Lor_bp,
];
var EDBtnDataArray_8 = [
    EDMmlFormulaIndex.Int,

    EDMmlFormulaIndex.Int_b,

    EDMmlFormulaIndex.Int_bp,

    EDMmlFormulaIndex.Int_u,

    EDMmlFormulaIndex.Int_uo,

    EDMmlFormulaIndex.DoubleInt,

    EDMmlFormulaIndex.DoubleInt_b,

    EDMmlFormulaIndex.DoubleInt_bp,

    EDMmlFormulaIndex.DoubleInt_u,

    EDMmlFormulaIndex.DoubleInt_uo,

    EDMmlFormulaIndex.TripleInt,

    EDMmlFormulaIndex.TripleInt_b,

    EDMmlFormulaIndex.TripleInt_bp,

    EDMmlFormulaIndex.TripleInt_u,

    EDMmlFormulaIndex.TripleInt_uo,

    EDMmlFormulaIndex.ContourInt,

    EDMmlFormulaIndex.ContourInt_b,

    EDMmlFormulaIndex.ContourInt_bp,

    EDMmlFormulaIndex.ContourInt_u,

    EDMmlFormulaIndex.ContourInt_uo,

    EDMmlFormulaIndex.SurfaceInt,

    EDMmlFormulaIndex.SurfaceInt_b,

    EDMmlFormulaIndex.SurfaceInt_bp,

    EDMmlFormulaIndex.SurfaceInt_u,

    EDMmlFormulaIndex.SurfaceInt_uo,

    EDMmlFormulaIndex.VolumeInt,

    EDMmlFormulaIndex.VolumeInt_b,

    EDMmlFormulaIndex.VolumeInt_bp,

    EDMmlFormulaIndex.VolumeInt_u,

    EDMmlFormulaIndex.VolumeInt_uo,

    EDMmlFormulaIndex.ClockwiseContInt,

    EDMmlFormulaIndex.ClockwiseContInt_b,

    EDMmlFormulaIndex.ClockwiseContInt_bp,

    EDMmlFormulaIndex.ClockwiseContInt_u,

    EDMmlFormulaIndex.ClockwiseContInt_uo,

    EDMmlFormulaIndex.ClockwiseInt,

    EDMmlFormulaIndex.ClockwiseInt_b,

    EDMmlFormulaIndex.ClockwiseInt_bp,

    EDMmlFormulaIndex.ClockwiseInt_u,

    EDMmlFormulaIndex.ClockwiseInt_uo,

    EDMmlFormulaIndex.CtClockwiseInt,

    EDMmlFormulaIndex.CtClockwiseInt_b,

    EDMmlFormulaIndex.CtClockwiseInt_bp,

    EDMmlFormulaIndex.CtClockwiseInt_u,

    EDMmlFormulaIndex.CtClockwiseInt_uo,

    EDMmlFormulaIndex.CtClockwiseContInt,

    EDMmlFormulaIndex.CtClockwiseContInt_b,

    EDMmlFormulaIndex.CtClockwiseContInt_bp,

    EDMmlFormulaIndex.CtClockwiseContInt_u,

    EDMmlFormulaIndex.CtClockwiseContInt_uo,

    EDMmlFormulaIndex.QuadrupleInt,

    EDMmlFormulaIndex.QuadrupleInt_b,

    EDMmlFormulaIndex.QuadrupleInt_bp,

    EDMmlFormulaIndex.QuadrupleInt_u,

    EDMmlFormulaIndex.QuadrupleInt_uo,
];
var EDBtnDataArray_9 = [
    EDMmlFormulaIndex.OverTilde,

    EDMmlFormulaIndex.Parentheses_o,

    EDMmlFormulaIndex.OverHat,

    EDMmlFormulaIndex.SquareBracket_o,

    EDMmlFormulaIndex.OverShellBracket,

    EDMmlFormulaIndex.CurlyBracket_o,

    EDMmlFormulaIndex.OverBar,

    EDMmlFormulaIndex.OverDoubleBar,

    EDMmlFormulaIndex.Enclose_tl,

    EDMmlFormulaIndex.Enclose_tr,

    EDMmlFormulaIndex.UnderTilde,

    EDMmlFormulaIndex.Parentheses_u,

    EDMmlFormulaIndex.UnderHat,

    EDMmlFormulaIndex.SquareBracket_u,

    EDMmlFormulaIndex.UnderShellBracket,

    EDMmlFormulaIndex.CurlyBracket_u,

    EDMmlFormulaIndex.UnderBar,

    EDMmlFormulaIndex.UnderDoubleBar,

    EDMmlFormulaIndex.Enclose_bl,

    EDMmlFormulaIndex.Enclose_br,

    EDMmlFormulaIndex.OverShortRightArr,

    EDMmlFormulaIndex.OverLeftRightArrow,

    EDMmlFormulaIndex.OverShortLeftArr,

    EDMmlFormulaIndex.OverRightVector,

    EDMmlFormulaIndex.OverLeftRightVector,

    EDMmlFormulaIndex.OverLeftVector,

    EDMmlFormulaIndex.Enclose_hor,

    EDMmlFormulaIndex.Enclose_down,

    EDMmlFormulaIndex.Enclose_up,

    EDMmlFormulaIndex.Enclose_updown,

    EDMmlFormulaIndex.UnderShortRightArr,

    EDMmlFormulaIndex.UnderLeftRightArrow,

    EDMmlFormulaIndex.UnderShortLeftArr,

    EDMmlFormulaIndex.UnderRightVector,

    EDMmlFormulaIndex.UnderLeftRightVector,

    EDMmlFormulaIndex.UnderLeftVector,

    EDMmlFormulaIndex.Enclose_box,
];
var EDBtnDataArray_10 = [
    EDMmlFormulaIndex.RightArr_o,

    EDMmlFormulaIndex.RightArr_u,

    EDMmlFormulaIndex.RightArr_uo,

    EDMmlFormulaIndex.LeftArr_o,

    EDMmlFormulaIndex.LeftArr_u,

    EDMmlFormulaIndex.LeftArr_uo,

    EDMmlFormulaIndex.LeftRightArr_o,

    EDMmlFormulaIndex.LeftRightArr_u,

    EDMmlFormulaIndex.LeftRightArr_uo,

    EDMmlFormulaIndex.RightArrLeftArr_o,

    EDMmlFormulaIndex.RightArrLeftArr_u,

    EDMmlFormulaIndex.RightArrLeftArr_uo,

    EDMmlFormulaIndex.LRightArrSLeftArr_o,

    EDMmlFormulaIndex.LRightArrSLeftArr_u,

    EDMmlFormulaIndex.LRightArrSLeftArr_uo,

    EDMmlFormulaIndex.SRightArrLLeftArr_o,

    EDMmlFormulaIndex.SRightArrLLeftArr_u,

    EDMmlFormulaIndex.SRightArrLLeftArr_uo,

    EDMmlFormulaIndex.Equilibrium_o,

    EDMmlFormulaIndex.Equilibrium_u,

    EDMmlFormulaIndex.Equilibrium_uo,

    EDMmlFormulaIndex.LRightVerSLeftVer_o,

    EDMmlFormulaIndex.LRightVerSLeftVer_u,

    EDMmlFormulaIndex.LRightVerSLeftVer_uo,

    EDMmlFormulaIndex.SRightVerLLeftVer_o,

    EDMmlFormulaIndex.SRightVerLLeftVer_u,

    EDMmlFormulaIndex.SRightVerLLeftVer_uo,
];
var EDBtnDataArray_11 = [EDMmlFormulaIndex.mellip, EDMmlFormulaIndex.vellip, EDMmlFormulaIndex.urellip, EDMmlFormulaIndex.rrellip];
var EDBtnDataArray = [
    EDBtnDataArray_0,
    EDBtnDataArray_1,
    EDBtnDataArray_2,
    EDBtnDataArray_3,
    EDBtnDataArray_4,
    EDBtnDataArray_5,
    EDBtnDataArray_6,
    EDBtnDataArray_7,
    EDBtnDataArray_8,
    EDBtnDataArray_9,
    EDBtnDataArray_10,
    EDBtnDataArray_11,
];

// 矩阵数组
var EDMtableArray = [
    //[row,col]
    "填充",
    [1, 2],
    [2, 1],
    [2, 2],
    "填充",
    [1, 3],
    [3, 1],
    [3, 3],
    "填充",
    [1, 4],
    [4, 1],
    [4, 4],
];
export default {
    mounted() {},
    data() {
        return {
            EDBtnDataArray,
            EDMtableArray,
            //list数组包含的是图标的src
            list: [
                {
                    id: "box1",
                    list: [
                        require("@/public/img/symbol/symbol/symbol1/1.png"),
                        require("@/public/img/symbol/symbol/symbol1/2.png"),
                        require("@/public/img/symbol/symbol/symbol1/3.png"),
                        require("@/public/img/symbol/symbol/symbol1/4.png"),
                        require("@/public/img/symbol/symbol/symbol1/5.png"),
                        require("@/public/img/symbol/symbol/symbol1/6.png"),
                        require("@/public/img/symbol/symbol/symbol1/7.png"),
                        require("@/public/img/symbol/symbol/symbol1/8.png"),
                        require("@/public/img/symbol/symbol/symbol1/9.png"),
                        require("@/public/img/symbol/symbol/symbol1/10.png"),
                        require("@/public/img/symbol/symbol/symbol1/11.png"),
                        require("@/public/img/symbol/symbol/symbol1/12.png"),
                        require("@/public/img/symbol/symbol/symbol1/13.png"),
                        require("@/public/img/symbol/symbol/symbol1/14.png"),
                        require("@/public/img/symbol/symbol/symbol1/15.png"),
                        require("@/public/img/symbol/symbol/symbol1/16.png"),
                        require("@/public/img/symbol/symbol/symbol1/17.png"),
                        require("@/public/img/symbol/symbol/symbol1/18.png"),
                        require("@/public/img/symbol/symbol/symbol1/19.png"),
                        require("@/public/img/symbol/symbol/symbol1/20.png"),
                        require("@/public/img/symbol/symbol/symbol1/21.png"),
                        require("@/public/img/symbol/symbol/symbol1/22.png"),
                        require("@/public/img/symbol/symbol/symbol1/23.png"),
                        require("@/public/img/symbol/symbol/symbol1/24.png"),
                        require("@/public/img/symbol/symbol/symbol1/25.png"),
                        require("@/public/img/symbol/symbol/symbol1/26.png"),
                        require("@/public/img/symbol/symbol/symbol1/27.png"),
                        require("@/public/img/symbol/symbol/symbol1/28.png"),
                        require("@/public/img/symbol/symbol/symbol1/29.png"),
                        require("@/public/img/symbol/symbol/symbol1/30.png"),
                        require("@/public/img/symbol/symbol/symbol1/31.png"),
                        require("@/public/img/symbol/symbol/symbol1/32.png"),
                        require("@/public/img/symbol/symbol/symbol1/33.png"),
                        require("@/public/img/symbol/symbol/symbol1/34.png"),
                        require("@/public/img/symbol/symbol/symbol1/more.png"),
                    ],
                },
                {
                    id: "box2",
                    list: [
                        require("@/public/img/symbol/symbol/symbol2/1.png"),
                        require("@/public/img/symbol/symbol/symbol2/2.png"),
                        require("@/public/img/symbol/symbol/symbol2/3.png"),
                        require("@/public/img/symbol/symbol/symbol2/4.png"),
                        require("@/public/img/symbol/symbol/symbol2/5.png"),
                        require("@/public/img/symbol/symbol/symbol2/6.png"),
                        require("@/public/img/symbol/symbol/symbol2/7.png"),
                        require("@/public/img/symbol/symbol/symbol2/8.png"),
                        require("@/public/img/symbol/symbol/symbol2/9.png"),
                        require("@/public/img/symbol/symbol/symbol2/10.png"),
                        require("@/public/img/symbol/symbol/symbol2/11.png"),
                        require("@/public/img/symbol/symbol/symbol2/12.png"),
                        require("@/public/img/symbol/symbol/symbol2/13.png"),
                        require("@/public/img/symbol/symbol/symbol2/14.png"),
                        require("@/public/img/symbol/symbol/symbol2/15.png"),
                        require("@/public/img/symbol/symbol/symbol2/16.png"),
                        require("@/public/img/symbol/symbol/symbol2/17.png"),
                        require("@/public/img/symbol/symbol/symbol2/18.png"),
                        require("@/public/img/symbol/symbol/symbol2/19.png"),
                        require("@/public/img/symbol/symbol/symbol2/20.png"),
                        require("@/public/img/symbol/symbol/symbol2/21.png"),
                        require("@/public/img/symbol/symbol/symbol2/22.png"),
                        require("@/public/img/symbol/symbol/symbol2/23.png"),
                        require("@/public/img/symbol/symbol/symbol2/24.png"),
                        require("@/public/img/symbol/symbol/symbol2/25.png"),
                        require("@/public/img/symbol/symbol/symbol2/26.png"),
                        require("@/public/img/symbol/symbol/symbol2/27.png"),
                        require("@/public/img/symbol/symbol/symbol2/28.png"),
                        require("@/public/img/symbol/symbol/symbol2/29.png"),
                        require("@/public/img/symbol/symbol/symbol2/30.png"),
                        require("@/public/img/symbol/symbol/symbol2/31.png"),
                        require("@/public/img/symbol/symbol/symbol2/32.png"),
                        require("@/public/img/symbol/symbol/symbol2/33.png"),
                        require("@/public/img/symbol/symbol/symbol2/34.png"),
                        require("@/public/img/symbol/symbol/symbol2/35.png"),
                        require("@/public/img/symbol/symbol/symbol2/36.png"),
                        require("@/public/img/symbol/symbol/symbol2/37.png"),
                        require("@/public/img/symbol/symbol/symbol2/38.png"),
                        require("@/public/img/symbol/symbol/symbol2/39.png"),
                        require("@/public/img/symbol/symbol/symbol2/40.png"),
                        require("@/public/img/symbol/symbol/symbol2/41.png"),
                        require("@/public/img/symbol/symbol/symbol2/42.png"),
                        require("@/public/img/symbol/symbol/symbol2/43.png"),
                    ],
                },
                {
                    id: "box3",
                    list: [
                        require("@/public/img/symbol/symbol/symbol3/1.png"),
                        require("@/public/img/symbol/symbol/symbol3/2.png"),
                        require("@/public/img/symbol/symbol/symbol3/3.png"),
                        require("@/public/img/symbol/symbol/symbol3/4.png"),
                        require("@/public/img/symbol/symbol/symbol3/5.png"),
                        require("@/public/img/symbol/symbol/symbol3/6.png"),
                        require("@/public/img/symbol/symbol/symbol3/7.png"),
                        require("@/public/img/symbol/symbol/symbol3/8.png"),
                        require("@/public/img/symbol/symbol/symbol3/9.png"),
                        require("@/public/img/symbol/symbol/symbol3/10.png"),
                        require("@/public/img/symbol/symbol/symbol3/11.png"),
                        require("@/public/img/symbol/symbol/symbol3/12.png"),
                        require("@/public/img/symbol/symbol/symbol3/13.png"),
                        require("@/public/img/symbol/symbol/symbol3/14.png"),
                        require("@/public/img/symbol/symbol/symbol3/15.png"),
                        require("@/public/img/symbol/symbol/symbol3/16.png"),
                        require("@/public/img/symbol/symbol/symbol3/17.png"),
                        require("@/public/img/symbol/symbol/symbol3/18.png"),
                        require("@/public/img/symbol/symbol/symbol3/19.png"),
                        require("@/public/img/symbol/symbol/symbol3/20.png"),
                        require("@/public/img/symbol/symbol/symbol3/21.png"),
                        require("@/public/img/symbol/symbol/symbol3/22.png"),
                        require("@/public/img/symbol/symbol/symbol3/23.png"),
                        require("@/public/img/symbol/symbol/symbol3/24.png"),
                        require("@/public/img/symbol/symbol/symbol3/25.png"),
                        require("@/public/img/symbol/symbol/symbol3/26.png"),
                        // require("@/public/img/symbol/symbol/symbol1/more.png")
                        "more",
                    ],
                },

                {
                    id: "box4",
                    list: [
                        require("@/public/img/symbol/symbol/symbol5/1.png"),
                        require("@/public/img/symbol/symbol/symbol5/2.png"),
                        require("@/public/img/symbol/symbol/symbol5/3.png"),
                        require("@/public/img/symbol/symbol/symbol5/4.png"),
                        require("@/public/img/symbol/symbol/symbol5/5.png"),
                        require("@/public/img/symbol/symbol/symbol5/6.png"),
                        require("@/public/img/symbol/symbol/symbol5/7.png"),
                        require("@/public/img/symbol/symbol/symbol5/8.png"),
                        require("@/public/img/symbol/symbol/symbol5/9.png"),
                        require("@/public/img/symbol/symbol/symbol5/10.png"),
                        require("@/public/img/symbol/symbol/symbol5/11.png"),
                        require("@/public/img/symbol/symbol/symbol5/12.png"),
                        require("@/public/img/symbol/symbol/symbol5/13.png"),
                        require("@/public/img/symbol/symbol/symbol5/14.png"),
                        require("@/public/img/symbol/symbol/symbol5/15.png"),
                        require("@/public/img/symbol/symbol/symbol5/16.png"),
                        require("@/public/img/symbol/symbol/symbol5/17.png"),
                        require("@/public/img/symbol/symbol/symbol5/18.png"),
                        require("@/public/img/symbol/symbol/symbol5/19.png"),
                        require("@/public/img/symbol/symbol/symbol5/20.png"),
                        require("@/public/img/symbol/symbol/symbol5/21.png"),
                        require("@/public/img/symbol/symbol/symbol5/22.png"),
                        require("@/public/img/symbol/symbol/symbol5/23.png"),
                        require("@/public/img/symbol/symbol/symbol5/24.png"),
                        require("@/public/img/symbol/symbol/symbol5/25.png"),
                        require("@/public/img/symbol/symbol/symbol5/26.png"),
                        require("@/public/img/symbol/symbol/symbol5/27.png"),
                        require("@/public/img/symbol/symbol/symbol5/28.png"),
                        require("@/public/img/symbol/symbol/symbol5/29.png"),
                        require("@/public/img/symbol/symbol/symbol5/30.png"),
                        require("@/public/img/symbol/symbol/symbol5/31.png"),
                        require("@/public/img/symbol/symbol/symbol5/32.png"),
                        require("@/public/img/symbol/symbol/symbol5/33.png"),
                        require("@/public/img/symbol/symbol/symbol5/34.png"),
                        require("@/public/img/symbol/symbol/symbol5/35.png"),
                    ],
                },
                {
                    id: "box5",
                    list: [
                        require("@/public/img/symbol/symbol/symbol6/1.png"),
                        require("@/public/img/symbol/symbol/symbol6/2.png"),
                        require("@/public/img/symbol/symbol/symbol6/3.png"),
                        require("@/public/img/symbol/symbol/symbol6/4.png"),
                        require("@/public/img/symbol/symbol/symbol6/5.png"),
                        require("@/public/img/symbol/symbol/symbol6/6.png"),
                        require("@/public/img/symbol/symbol/symbol6/7.png"),
                        require("@/public/img/symbol/symbol/symbol6/8.png"),
                        require("@/public/img/symbol/symbol/symbol6/9.png"),
                        require("@/public/img/symbol/symbol/symbol6/10.png"),
                        require("@/public/img/symbol/symbol/symbol6/11.png"),
                        require("@/public/img/symbol/symbol/symbol6/12.png"),
                        require("@/public/img/symbol/symbol/symbol6/13.png"),
                        require("@/public/img/symbol/symbol/symbol6/14.png"),
                        require("@/public/img/symbol/symbol/symbol6/15.png"),
                        require("@/public/img/symbol/symbol/symbol6/16.png"),
                        require("@/public/img/symbol/symbol/symbol6/17.png"),
                        require("@/public/img/symbol/symbol/symbol6/18.png"),
                        require("@/public/img/symbol/symbol/symbol6/19.png"),
                        require("@/public/img/symbol/symbol/symbol6/20.png"),
                        require("@/public/img/symbol/symbol/symbol6/21.png"),
                        require("@/public/img/symbol/symbol/symbol6/22.png"),
                        require("@/public/img/symbol/symbol/symbol6/23.png"),
                        require("@/public/img/symbol/symbol/symbol6/24.png"),
                        require("@/public/img/symbol/symbol/symbol6/25.png"),
                        require("@/public/img/symbol/symbol/symbol6/26.png"),
                        require("@/public/img/symbol/symbol/symbol6/27.png"),
                        require("@/public/img/symbol/symbol/symbol6/28.png"),
                        require("@/public/img/symbol/symbol/symbol6/29.png"),
                        require("@/public/img/symbol/symbol/symbol6/30.png"),
                        require("@/public/img/symbol/symbol/symbol6/31.png"),
                        require("@/public/img/symbol/symbol/symbol6/32.png"),
                        require("@/public/img/symbol/symbol/symbol6/33.png"),
                        require("@/public/img/symbol/symbol/symbol6/34.png"),
                        require("@/public/img/symbol/symbol/symbol6/35.png"),
                        require("@/public/img/symbol/symbol/symbol6/36.png"),
                        require("@/public/img/symbol/symbol/symbol6/37.png"),
                        require("@/public/img/symbol/symbol/symbol6/38.png"),
                        require("@/public/img/symbol/symbol/symbol6/39.png"),
                        require("@/public/img/symbol/symbol/symbol6/40.png"),
                        require("@/public/img/symbol/symbol/symbol6/41.png"),
                        require("@/public/img/symbol/symbol/symbol6/42.png"),
                        require("@/public/img/symbol/symbol/symbol6/43.png"),
                        require("@/public/img/symbol/symbol/symbol6/44.png"),
                        require("@/public/img/symbol/symbol/symbol6/45.png"),
                        require("@/public/img/symbol/symbol/symbol6/46.png"),
                        require("@/public/img/symbol/symbol/symbol6/47.png"),
                        require("@/public/img/symbol/symbol/symbol6/48.png"),
                        require("@/public/img/symbol/symbol/symbol6/49.png"),
                        require("@/public/img/symbol/symbol/symbol6/50.png"),
                        require("@/public/img/symbol/symbol/symbol6/51.png"),
                        require("@/public/img/symbol/symbol/symbol6/52.png"),
                    ],
                },
                {
                    id: "box6",
                    list: [
                        require("@/public/img/symbol/symbol/symbol7/1.png"),
                        require("@/public/img/symbol/symbol/symbol7/2.png"),
                        require("@/public/img/symbol/symbol/symbol7/3.png"),
                        require("@/public/img/symbol/symbol/symbol7/4.png"),
                        require("@/public/img/symbol/symbol/symbol7/5.png"),
                        require("@/public/img/symbol/symbol/symbol7/6.png"),
                        require("@/public/img/symbol/symbol/symbol7/7.png"),
                        require("@/public/img/symbol/symbol/symbol7/8.png"),
                        require("@/public/img/symbol/symbol/symbol7/9.png"),
                        require("@/public/img/symbol/symbol/symbol7/10.png"),
                        require("@/public/img/symbol/symbol/symbol7/11.png"),
                        require("@/public/img/symbol/symbol/symbol7/12.png"),
                        require("@/public/img/symbol/symbol/symbol7/13.png"),
                        require("@/public/img/symbol/symbol/symbol7/14.png"),
                        require("@/public/img/symbol/symbol/symbol7/15.png"),
                        require("@/public/img/symbol/symbol/symbol7/16.png"),
                        require("@/public/img/symbol/symbol/symbol7/17.png"),
                        require("@/public/img/symbol/symbol/symbol7/18.png"),
                        require("@/public/img/symbol/symbol/symbol7/19.png"),
                        require("@/public/img/symbol/symbol/symbol7/20.png"),
                        require("@/public/img/symbol/symbol/symbol7/21.png"),
                        require("@/public/img/symbol/symbol/symbol7/22.png"),
                        require("@/public/img/symbol/symbol/symbol7/23.png"),
                        require("@/public/img/symbol/symbol/symbol7/24.png"),
                        require("@/public/img/symbol/symbol/symbol7/25.png"),
                        require("@/public/img/symbol/symbol/symbol7/26.png"),
                        require("@/public/img/symbol/symbol/symbol7/27.png"),
                        require("@/public/img/symbol/symbol/symbol7/28.png"),
                        require("@/public/img/symbol/symbol/symbol7/29.png"),
                        require("@/public/img/symbol/symbol/symbol7/30.png"),
                        require("@/public/img/symbol/symbol/symbol7/31.png"),
                        require("@/public/img/symbol/symbol/symbol7/32.png"),
                        require("@/public/img/symbol/symbol/symbol7/33.png"),
                        require("@/public/img/symbol/symbol/symbol7/34.png"),
                        require("@/public/img/symbol/symbol/symbol7/35.png"),
                        require("@/public/img/symbol/symbol/symbol7/36.png"),
                        require("@/public/img/symbol/symbol/symbol7/37.png"),
                        require("@/public/img/symbol/symbol/symbol7/38.png"),
                        require("@/public/img/symbol/symbol/symbol7/39.png"),
                        require("@/public/img/symbol/symbol/symbol7/40.png"),
                    ],
                },
                {
                    id: "box7",
                    list: [
                        require("@/public/img/symbol/symbol/symbol8/1.png"),
                        require("@/public/img/symbol/symbol/symbol8/2.png"),
                        require("@/public/img/symbol/symbol/symbol8/3.png"),
                        require("@/public/img/symbol/symbol/symbol8/4.png"),
                        require("@/public/img/symbol/symbol/symbol8/5.png"),
                        require("@/public/img/symbol/symbol/symbol8/6.png"),
                        require("@/public/img/symbol/symbol/symbol8/7.png"),
                        require("@/public/img/symbol/symbol/symbol8/8.png"),
                        require("@/public/img/symbol/symbol/symbol8/9.png"),
                        require("@/public/img/symbol/symbol/symbol8/10.png"),
                        require("@/public/img/symbol/symbol/symbol8/11.png"),
                        require("@/public/img/symbol/symbol/symbol8/12.png"),
                        require("@/public/img/symbol/symbol/symbol8/13.png"),
                        require("@/public/img/symbol/symbol/symbol8/14.png"),
                        require("@/public/img/symbol/symbol/symbol8/15.png"),
                        require("@/public/img/symbol/symbol/symbol8/16.png"),
                        require("@/public/img/symbol/symbol/symbol8/17.png"),
                        require("@/public/img/symbol/symbol/symbol8/18.png"),
                        require("@/public/img/symbol/symbol/symbol8/19.png"),
                        require("@/public/img/symbol/symbol/symbol8/20.png"),
                        require("@/public/img/symbol/symbol/symbol8/21.png"),
                        require("@/public/img/symbol/symbol/symbol8/22.png"),
                        require("@/public/img/symbol/symbol/symbol8/23.png"),
                        require("@/public/img/symbol/symbol/symbol8/24.png"),
                        require("@/public/img/symbol/symbol/symbol8/25.png"),
                        require("@/public/img/symbol/symbol/symbol8/26.png"),
                        require("@/public/img/symbol/symbol/symbol8/27.png"),
                        require("@/public/img/symbol/symbol/symbol8/28.png"),
                        require("@/public/img/symbol/symbol/symbol8/29.png"),
                        require("@/public/img/symbol/symbol/symbol8/30.png"),
                        require("@/public/img/symbol/symbol/symbol8/31.png"),
                        require("@/public/img/symbol/symbol/symbol8/32.png"),
                        require("@/public/img/symbol/symbol/symbol8/33.png"),
                        require("@/public/img/symbol/symbol/symbol8/34.png"),
                        require("@/public/img/symbol/symbol/symbol8/35.png"),
                    ],
                },
                {
                    id: "box8",
                    list: [
                        require("@/public/img/symbol/symbol/symbol9/1.png"),
                        require("@/public/img/symbol/symbol/symbol9/2.png"),
                        require("@/public/img/symbol/symbol/symbol9/3.png"),
                        require("@/public/img/symbol/symbol/symbol9/4.png"),
                        require("@/public/img/symbol/symbol/symbol9/5.png"),
                        require("@/public/img/symbol/symbol/symbol9/6.png"),
                        require("@/public/img/symbol/symbol/symbol9/7.png"),
                        require("@/public/img/symbol/symbol/symbol9/8.png"),
                        require("@/public/img/symbol/symbol/symbol9/9.png"),
                        require("@/public/img/symbol/symbol/symbol9/10.png"),
                        require("@/public/img/symbol/symbol/symbol9/11.png"),
                        require("@/public/img/symbol/symbol/symbol9/12.png"),
                        require("@/public/img/symbol/symbol/symbol9/13.png"),
                        require("@/public/img/symbol/symbol/symbol9/14.png"),
                        require("@/public/img/symbol/symbol/symbol9/15.png"),
                        require("@/public/img/symbol/symbol/symbol9/16.png"),
                        require("@/public/img/symbol/symbol/symbol9/17.png"),
                        require("@/public/img/symbol/symbol/symbol9/18.png"),
                        require("@/public/img/symbol/symbol/symbol9/19.png"),
                        require("@/public/img/symbol/symbol/symbol9/20.png"),
                        require("@/public/img/symbol/symbol/symbol9/21.png"),
                        require("@/public/img/symbol/symbol/symbol9/22.png"),
                        require("@/public/img/symbol/symbol/symbol9/23.png"),
                        require("@/public/img/symbol/symbol/symbol9/24.png"),
                        require("@/public/img/symbol/symbol/symbol9/25.png"),
                        require("@/public/img/symbol/symbol/symbol9/26.png"),
                        require("@/public/img/symbol/symbol/symbol9/27.png"),
                        require("@/public/img/symbol/symbol/symbol9/28.png"),
                        require("@/public/img/symbol/symbol/symbol9/29.png"),
                        require("@/public/img/symbol/symbol/symbol9/30.png"),
                        require("@/public/img/symbol/symbol/symbol9/31.png"),
                        require("@/public/img/symbol/symbol/symbol9/32.png"),
                        require("@/public/img/symbol/symbol/symbol9/33.png"),
                        require("@/public/img/symbol/symbol/symbol9/34.png"),
                        require("@/public/img/symbol/symbol/symbol9/35.png"),
                    ],
                },
                {
                    id: "box9",
                    list: [
                        require("@/public/img/symbol/symbol/symbol10/1.png"),
                        require("@/public/img/symbol/symbol/symbol10/2.png"),
                        require("@/public/img/symbol/symbol/symbol10/3.png"),
                        require("@/public/img/symbol/symbol/symbol10/4.png"),
                        require("@/public/img/symbol/symbol/symbol10/5.png"),
                        require("@/public/img/symbol/symbol/symbol10/6.png"),
                        require("@/public/img/symbol/symbol/symbol10/7.png"),
                        require("@/public/img/symbol/symbol/symbol10/8.png"),
                        require("@/public/img/symbol/symbol/symbol10/9.png"),
                        require("@/public/img/symbol/symbol/symbol10/10.png"),
                        require("@/public/img/symbol/symbol/symbol10/11.png"),
                        require("@/public/img/symbol/symbol/symbol10/12.png"),
                        require("@/public/img/symbol/symbol/symbol10/13.png"),
                        require("@/public/img/symbol/symbol/symbol10/14.png"),
                        require("@/public/img/symbol/symbol/symbol10/15.png"),
                        require("@/public/img/symbol/symbol/symbol10/16.png"),
                        require("@/public/img/symbol/symbol/symbol10/17.png"),
                        require("@/public/img/symbol/symbol/symbol10/18.png"),
                        require("@/public/img/symbol/symbol/symbol10/19.png"),
                        require("@/public/img/symbol/symbol/symbol10/20.png"),
                        require("@/public/img/symbol/symbol/symbol10/21.png"),
                        require("@/public/img/symbol/symbol/symbol10/22.png"),
                        require("@/public/img/symbol/symbol/symbol10/23.png"),
                        require("@/public/img/symbol/symbol/symbol10/24.png"),
                        require("@/public/img/symbol/symbol/symbol10/25.png"),
                        require("@/public/img/symbol/symbol/symbol10/26.png"),
                        require("@/public/img/symbol/symbol/symbol10/27.png"),
                        require("@/public/img/symbol/symbol/symbol10/28.png"),
                        require("@/public/img/symbol/symbol/symbol10/29.png"),
                        require("@/public/img/symbol/symbol/symbol10/30.png"),
                        require("@/public/img/symbol/symbol/symbol10/31.png"),
                        require("@/public/img/symbol/symbol/symbol10/32.png"),
                        require("@/public/img/symbol/symbol/symbol10/33.png"),
                        require("@/public/img/symbol/symbol/symbol10/34.png"),
                        require("@/public/img/symbol/symbol/symbol10/35.png"),
                        require("@/public/img/symbol/symbol/symbol10/36.png"),
                        require("@/public/img/symbol/symbol/symbol10/37.png"),
                        require("@/public/img/symbol/symbol/symbol10/38.png"),
                        require("@/public/img/symbol/symbol/symbol10/39.png"),
                        require("@/public/img/symbol/symbol/symbol10/40.png"),
                        require("@/public/img/symbol/symbol/symbol10/41.png"),
                        require("@/public/img/symbol/symbol/symbol10/42.png"),
                        require("@/public/img/symbol/symbol/symbol10/43.png"),
                        require("@/public/img/symbol/symbol/symbol10/44.png"),
                        require("@/public/img/symbol/symbol/symbol10/45.png"),
                        require("@/public/img/symbol/symbol/symbol10/46.png"),
                        require("@/public/img/symbol/symbol/symbol10/47.png"),
                        require("@/public/img/symbol/symbol/symbol10/48.png"),
                        require("@/public/img/symbol/symbol/symbol10/49.png"),
                        require("@/public/img/symbol/symbol/symbol10/50.png"),
                        require("@/public/img/symbol/symbol/symbol10/51.png"),
                        require("@/public/img/symbol/symbol/symbol10/52.png"),
                        require("@/public/img/symbol/symbol/symbol10/53.png"),
                        require("@/public/img/symbol/symbol/symbol10/54.png"),
                        require("@/public/img/symbol/symbol/symbol10/55.png"),
                    ],
                },
                {
                    id: "box10",
                    list: [
                        require("@/public/img/symbol/symbol/symbol11/1.png"),
                        require("@/public/img/symbol/symbol/symbol11/2.png"),
                        require("@/public/img/symbol/symbol/symbol11/3.png"),
                        require("@/public/img/symbol/symbol/symbol11/4.png"),
                        require("@/public/img/symbol/symbol/symbol11/5.png"),
                        require("@/public/img/symbol/symbol/symbol11/6.png"),
                        require("@/public/img/symbol/symbol/symbol11/7.png"),
                        require("@/public/img/symbol/symbol/symbol11/8.png"),
                        require("@/public/img/symbol/symbol/symbol11/9.png"),
                        require("@/public/img/symbol/symbol/symbol11/10.png"),
                        require("@/public/img/symbol/symbol/symbol11/11.png"),
                        require("@/public/img/symbol/symbol/symbol11/12.png"),
                        require("@/public/img/symbol/symbol/symbol11/13.png"),
                        require("@/public/img/symbol/symbol/symbol11/14.png"),
                        require("@/public/img/symbol/symbol/symbol11/15.png"),
                        require("@/public/img/symbol/symbol/symbol11/16.png"),
                        require("@/public/img/symbol/symbol/symbol11/17.png"),
                        require("@/public/img/symbol/symbol/symbol11/18.png"),
                        require("@/public/img/symbol/symbol/symbol11/19.png"),
                        require("@/public/img/symbol/symbol/symbol11/20.png"),
                        require("@/public/img/symbol/symbol/symbol11/21.png"),
                        require("@/public/img/symbol/symbol/symbol11/22.png"),
                        require("@/public/img/symbol/symbol/symbol11/23.png"),
                        require("@/public/img/symbol/symbol/symbol11/24.png"),
                        require("@/public/img/symbol/symbol/symbol11/25.png"),
                        require("@/public/img/symbol/symbol/symbol11/26.png"),
                        require("@/public/img/symbol/symbol/symbol11/27.png"),
                        require("@/public/img/symbol/symbol/symbol11/28.png"),
                        require("@/public/img/symbol/symbol/symbol11/29.png"),
                        require("@/public/img/symbol/symbol/symbol11/30.png"),
                        require("@/public/img/symbol/symbol/symbol11/31.png"),
                        require("@/public/img/symbol/symbol/symbol11/32.png"),
                        require("@/public/img/symbol/symbol/symbol11/33.png"),
                        require("@/public/img/symbol/symbol/symbol11/34.png"),
                        require("@/public/img/symbol/symbol/symbol11/35.png"),
                        require("@/public/img/symbol/symbol/symbol11/36.png"),
                        require("@/public/img/symbol/symbol/symbol11/37.png"),
                    ],
                },
                {
                    id: "box11",
                    list: [
                        require("@/public/img/symbol/symbol/symbol12/1.png"),
                        require("@/public/img/symbol/symbol/symbol12/2.png"),
                        require("@/public/img/symbol/symbol/symbol12/3.png"),
                        require("@/public/img/symbol/symbol/symbol12/4.png"),
                        require("@/public/img/symbol/symbol/symbol12/5.png"),
                        require("@/public/img/symbol/symbol/symbol12/6.png"),
                        require("@/public/img/symbol/symbol/symbol12/7.png"),
                        require("@/public/img/symbol/symbol/symbol12/8.png"),
                        require("@/public/img/symbol/symbol/symbol12/9.png"),
                        require("@/public/img/symbol/symbol/symbol12/10.png"),
                        require("@/public/img/symbol/symbol/symbol12/11.png"),
                        require("@/public/img/symbol/symbol/symbol12/12.png"),
                        require("@/public/img/symbol/symbol/symbol12/13.png"),
                        require("@/public/img/symbol/symbol/symbol12/14.png"),
                        require("@/public/img/symbol/symbol/symbol12/15.png"),
                        require("@/public/img/symbol/symbol/symbol12/16.png"),
                        require("@/public/img/symbol/symbol/symbol12/17.png"),
                        require("@/public/img/symbol/symbol/symbol12/18.png"),
                        require("@/public/img/symbol/symbol/symbol12/19.png"),
                        require("@/public/img/symbol/symbol/symbol12/20.png"),
                        require("@/public/img/symbol/symbol/symbol12/21.png"),
                        require("@/public/img/symbol/symbol/symbol12/22.png"),
                        require("@/public/img/symbol/symbol/symbol12/23.png"),
                        require("@/public/img/symbol/symbol/symbol12/24.png"),
                        require("@/public/img/symbol/symbol/symbol12/25.png"),
                        require("@/public/img/symbol/symbol/symbol12/26.png"),
                        require("@/public/img/symbol/symbol/symbol12/27.png"),
                    ],
                },
                {
                    id: "box12",
                    list: [
                        require("@/public/img/symbol/symbol/symbol13/11.png"),
                        require("@/public/img/symbol/symbol/symbol13/1.png"),
                        require("@/public/img/symbol/symbol/symbol13/2.png"),
                        require("@/public/img/symbol/symbol/symbol13/3.png"),

                        require("@/public/img/symbol/symbol/symbol13/12.png"),
                        require("@/public/img/symbol/symbol/symbol13/4.png"),
                        require("@/public/img/symbol/symbol/symbol13/5.png"),
                        require("@/public/img/symbol/symbol/symbol13/6.png"),

                        require("@/public/img/symbol/symbol/symbol13/13.png"),
                        require("@/public/img/symbol/symbol/symbol13/7.png"),
                        require("@/public/img/symbol/symbol/symbol13/8.png"),
                        require("@/public/img/symbol/symbol/symbol13/9.png"),
                        require("@/public/img/symbol/symbol/symbol13/14.png"),
                        require("@/public/img/symbol/symbol/symbol13/10.png"),
                    ],
                },
            ],
            //每一组的最大列数
            arrayNum: [20, 11, 7, 7, 13, 10, 9, 10, 15, 10, 7, 4],
            // 第一组数据的十进制索引值
            firstList: [
                43,
                45,
                215,
                247,
                42,
                11827,
                8729,
                8728,
                177,
                8723,
                61,
                8800,
                8801,
                8793,
                8796,
                8784,
                8765, //8764
                8776,
                8771,
                8780, //8773
                8733,
                62, // 65308
                60, // 65310
                8804,
                8805,
                8810,
                8811,
                8826,
                8827,
                8882,
                8883,
                8743,
                8744,
                8746,
                8745,
                8834,
                8835,
                8838,
                8839,
                8836,
                8837,
                8712,
                8713,
                8707,
                8708,
                8704,
                172,
                8710,
                8711,
                9675,
                9633,
                9645,
                9651,
                9649,
                8900,
                8853,
                8855,
                8857,
                8709,
                8736,
                8737,
                8738,
                8757,
                8756,
                8758,
                8739,
                8741,
                8869,
                8868,
                8866,
                8867,
            ],
            // 第四组数据的十进制索引值
            fourthList: [
                8706, 8734, 8224, 411, 8463, 8465, 8467, 8472, 8476, 8501, 8469, 8473, 8474, 8477, 8484, 8486, 8487, 8464, 8466, 8475, 8496, 8497,
                931, 8719, 8720, 8747, 176, 8900,
            ],
        };
    },
};
